import PropTypes from "prop-types";
import { useState, useEffect } from "react";


const UserDetailsForm = ({ user, getUsers, updateUser, loadUsers }) => {
  const [usuarios, setUsuarios] = useState([]); // State to hold the fetched users

  useEffect(() => {
  const fetchUsuarios = async () => {
    try {
      const usuariosData = await getUsers();
      const data = Array.isArray(usuariosData.data) ? usuariosData.data : [];
      setUsuarios(data); // Store the fetched users in state
    } catch (error) {
      console.error("Error fetching usuarios:", error);
      }
    };
    fetchUsuarios();
  }, [setUsuarios, getUsers]);

  const [isEditing, setIsEditing] = useState(false);

  const [formData, setFormData] = useState({
    id_usuario: String(user.id_usuario || ""), 
    usuario: user.usuario || "",
    nombre_completo: user.nombre_completo || "",
    alias: user.alias || "",
    celular_personal: user.celular_personal || "",
    whatsapp: user.whatsapp || "",
    fecha_nacimiento: user.fecha_nacimiento || "09/12/1988",
    genero: user.genero || "",
    estatura: user.estatura || 0.0,
    correo_electronico: user.correo_electronico || "",
    domicilio_1: user.domicilio_1 || "",
    domicilio_2: user.domicilio_2 || "",
    sangre: user.sangre || "",
    alergias: user.alergias || "",
    condiciones_medicas: user.condiciones_medicas || "",
    contacto_de_emergencia: user.contacto_de_emergencia || "",
    relación_contacto_de_emergencia: user.relación_contacto_de_emergencia || "",
    teléfono_contacto_de_emergencia: user.teléfono_contacto_de_emergencia || "",
    correo_electrónico_de_contacto_de_emergencia: user.correo_electrónico_de_contacto_de_emergencia || "",
    seguros_medicos: user.seguros_medicos || "",
    seguro_medico_primera_opción: user.seguro_medico_primera_opción || "",
    numero_seguro_social_imss: user.numero_seguro_social_imss || "",
    reto: user.reto || "",
    estado_reto: user.estado_reto || "",
    nombre_padrino: user.nombre_padrino || "",
    
  });  

  const [errors, setErrors] = useState({});  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    })); 

    const newErrors = { ...errors };
    const minEstatura = 1.0; // Estatura mínima permitida (en metros)
    const maxEstatura = 3; // Estatura máxima permitida (en metros)

    if (name === "nombre_completo") {
      if (!value || value.trim() === "") {
        newErrors.nombre_completo = "El campo no puede estar vacío.";
      } else {
        delete newErrors.nombre_completo;
      }
    }
    if (name === "celular_personal") {
      if (!/^\d{10}$/.test(value)) {
        newErrors.celular_personal = "El teléfono debe tener 10 dígitos y sin espacios.";
      } else {
        delete newErrors.celular_personal;
      }
    }
    if (name === "numero_seguro_social_imss") {
      if (!/^\d{11}$/.test(value)) {
        newErrors.numero_seguro_social_imss = "El numero de seguro debe tener 11 dígitos y sin espacios.";
      } else {
        delete newErrors.numero_seguro_social_imss;
      }
    }
    if (name === "estatura") {
      if (!formData.estatura || isNaN(formData.estatura) || formData.estatura < minEstatura || formData.estatura > maxEstatura) {
        newErrors.estatura = `La estatura es inusual, se permiten solo estaturas de ${minEstatura} mts a ${maxEstatura} mts.`;
      } else {
        delete newErrors.estatura;
      }
    }
    if (name === "whatsapp") {
      if(!value || value.trim() === ""){
        delete newErrors.whatsapp;
      } else if (/\s/.test(value)) {
        // Verifica si contiene espacios en blanco
        newErrors.whatsapp = "El whatsapp debe tener 10 dígitos y sin espacios.";
      } else if (!/^\d{10}$/.test(value)) {
        newErrors.whatsapp = "El whatsapp debe tener 10 dígitos y sin espacios.";
      } else {
        delete newErrors.whatsapp;
      }
    }
    if (name === "correo_electronico") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(value)) {
        newErrors.correo_electronico = "Por favor, ingresa un correo electrónico válido.";
      } else {
        delete newErrors.correo_electronico;
      }
    }

    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = { ...formData };
    try {
      dataToSend.estatura=parseFloat(dataToSend.estatura)

      await updateUser(formData.id_usuario, dataToSend);
      alert("Usuario actualizado con éxito.");
      await loadUsers();
    } catch (error) {
      console.error("Error actualizando usuario:", error);
    }    
  };
  const isFormInvalid = () => {
    // Verificar si hay errores en el objeto errors
    const hasErrors = Object.values(errors).some((error) => error !== "");

    // Verificar que los campos obligatorios estén llenos
    const requiredFieldsFilled = 
      user.nombre_completo !== "" &&
      user.celular_personal !== "";

    return hasErrors || !requiredFieldsFilled;
  };

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  return (
    <form onSubmit={handleSubmit}>
      <br></br>
      CURP: {user.curp}
      <p></p>
      {Object.keys(formData).map((key) => {
        if (key === "id_usuario" || key === "usuario") {
          return null; // Do not render these hidden fields
        }
        let inputElement;

        if (key === "genero") {
          // Render a select input for genero
          inputElement = (
            <select 
              name={key} 
              value={formData[key]} 
              onChange={handleChange} 
              disabled={!isEditing} 
              className="input"
            >
              <option value="masculino">Masculino</option>
              <option value="femenino">Femenino</option>
            </select>
          );
        }
        if (key === "nombre_padrino") {
          inputElement = (
            <select
              name={key}
              value={formData[key]}
              onChange={handleChange}
              disabled={!isEditing}
              className="input"
            >
              <option value="">Seleccione un padrino</option>
              {
              usuarios.map((data) => (
                <option key={data.id_usuario} value={data.id_usuario}>
                  {data.nombre_completo}
                </option>
              ))}
            </select>
          );
        }
        else {
          let inputType = "text";          
          if (key.startsWith("fecha")) inputType = "date";
          if (key === "correo_electronico" || key === "correo_electronico_de_contacto_de_emergencia") inputType = "email";

          inputElement = (
            <input
              type={inputType}
              name={key}
              value={formData[key]}
              onChange={handleChange}
              disabled={!isEditing} 
              /*required={key === "correo_electronico"} */
              className="input"
            />
          );
        }

        return (
          <div key={key} className="input-group">
            <label className="label">{key.replace(/_/g, " ")}</label>{errors[key] && <span className="error">{errors[key]}</span>}
            {inputElement}
          </div>
        );
      })}
      <p></p>
      <button type="button" onClick={handleEditClick} className="button">
        {isEditing ? "Proteger Campos" : "Modificar información"}
      </button>
      <p></p>
      <button type="submit" disabled={!isEditing} className={`${isFormInvalid() ? 'button-disabled' : 'button'}`}>
        Actualizar (Aplicar cambios)
      </button>
      <p></p>
    </form>    
  );
  
};

UserDetailsForm.propTypes = {
  user: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
  getUsers: PropTypes.func,
  loadUsers: PropTypes.func,
};



export default UserDetailsForm;

